import { useContext } from 'react';
import { intl, LanguageBaseContext } from "dmsbasereact";

export const useReturnReasons = () => {
    // Re-evaluate translations when language changes
    return {
        QUALITY_ISSUE: intl.get("QualityIssue").d("Quality Issue"),
        TREATMENT_DISCONTINUATION: intl.get("TreatmentDiscontinuation").d("Treatment Discontinuation"),
        ORDER_DIVERGENCE: intl.get("OrderDivergence").d("Order Divergence"),
    };
};

export const useReturnReasonOptions = () => {
    const return_reasons = useReturnReasons();

    return Object.entries(return_reasons).map(([key, value]) => ({
        value: key,
        label: value
    }));
};

export const RETURN_REASON_KEYS = {
    QUALITY_ISSUE: "QUALITY_ISSUE",
    TREATMENT_DISCONTINUATION: "TREATMENT_DISCONTINUATION",
    ORDER_DIVERGENCE: "ORDER_DIVERGENCE"
};